<div class="row">
    <div class="col-5">
        <div class="card">
            <div class="card-body bg-white">

                <h3>Seleccione el Tema</h3>

                <div class="r-panel-body">
                    <ul id="themecolors" class="m-t-20">
                        <li><b>Con el sidebar claro</b></li>
                        <li><button type="button" (click)="changeTheme('default')" data-theme="default" class="selector default-theme working">1</button></li>
                        <li><button type="button" (click)="changeTheme('green')" data-theme="green" class="selector green-theme">2</button></li>
                        <li><button type="button" (click)="changeTheme('red')" data-theme="red" class="selector red-theme">3</button></li>
                        <li><button type="button" (click)="changeTheme('blue')" data-theme="blue" class="selector blue-theme">4</button></li>
                        <li><button type="button" (click)="changeTheme('purple')" data-theme="purple" class="selector purple-theme">5</button></li>
                        <li><button type="button" (click)="changeTheme('megna')" data-theme="megna" class="selector megna-theme">6</button></li>

                        <li class="d-block m-t-30"><b>Con el sidebar oscuro</b></li>
                        <li><button type="button" (click)="changeTheme('default-dark')" data-theme="default-dark" class="selector default-dark-theme">7</button></li>
                        <li><button type="button" (click)="changeTheme('green-dark')" data-theme="green-dark" class="selector green-dark-theme">8</button></li>
                        <li><button type="button" (click)="changeTheme('red-dark')" data-theme="red-dark" class="selector red-dark-theme">9</button></li>
                        <li><button type="button" (click)="changeTheme('blue-dark')" data-theme="blue-dark" class="selector blue-dark-theme">10</button></li>
                        <li><button type="button" (click)="changeTheme('purple-dark')" data-theme="purple-dark" class="selector purple-dark-theme">11</button></li>
                        <li><button type="button" (click)="changeTheme('megna-dark')" data-theme="megna-dark" class="selector megna-dark-theme">12</button></li>
                    </ul>

                </div>



            </div>
        </div>
    </div>
</div>